import React from "react";
import Alert from "../common/Alert";

type ErrorProps = {
	padding?: string;
	className?: string;
	children: React.ReactNode;
};
function Error({ padding = "p-4", className = "", children }: ErrorProps) {
	return (
		<div className={"my-4"} data-testid="error-component">
			<Alert
				type="error"
				className={`flex flex-col gap-4 ${padding} ${className}`}
			>
				{children}
			</Alert>
		</div>
	);
}

export default Error;
